import React from "react";
import styles from "./styles/PlasticMouldingCTA.module.css";
import Icon from "../Home/common/Icon";
import ctaBg from "../../../images/contact-cta.jpg";

export default function PlasticMouldingCTA() {
  return (
    <section className={styles.cta} style={{ backgroundImage: `url(${ctaBg})` }}>
      <div className={styles.overlay} aria-hidden="true" />
      <div className={styles.container}>
        <p className={styles.text}>
          We have a team of skilled engineers ready to support you in your product development
          journey from prototyping to production.
        </p>
        <a href="/contact" className={styles.ctaBtn}>
          <span className={styles.ctaIcon} aria-hidden="true">
            <Icon.Phone />
          </span>
          <span>CONTACT US</span>
        </a>
        <div className={styles.divider} aria-hidden="true" />
      </div>
    </section>
  );
}
